var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navigation-bar" }, [
    _c(
      "div",
      { staticClass: "logo-container" },
      [
        _vm.deviceType !== "mobile" || _vm.isSlotEmpty("titleText")
          ? _c(
              "router-link",
              { staticClass: "link logo", attrs: { to: "overview" } },
              [
                !_vm.expanded
                  ? _c("div", { staticClass: "logo-image-container" }, [
                      _c("img", { attrs: { src: _vm.logo, alt: "Logo" } }),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "nav-bar-title", attrs: { id: "companyName" } },
      [_vm._t("titleText")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "icons-container",
        class: { "is-active": _vm.localIsMenuActive },
      },
      [
        _vm._t("iconsContainer"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-button" },
          [
            _c(
              "b-dropdown",
              {
                attrs: {
                  "aria-role": "menu",
                  triggers: ["click"],
                  position: "is-bottom-left",
                  "append-to-body": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function (ref) {
                      var active = ref.active
                      return [
                        _c(
                          "div",
                          { staticClass: "dropdown-control" },
                          [
                            _c("fa", {
                              style: { color: _vm.profileIconColor },
                              attrs: { icon: _vm.menuIcon, size: "xl" },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "nav-button-text" }, [
                              _vm._v("Hi, " + _vm._s(_vm.userName)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _vm._v(" "),
                _vm.showFeedbackLink
                  ? _c(
                      "b-dropdown-item",
                      { attrs: { "aria-role": "menuitem" } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "feedback" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.closeMenu.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "menu-button" },
                              [
                                _c("fa", {
                                  style: { color: _vm.menuButtonIconColor },
                                  attrs: { icon: "comment-dots", size: "sm" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "nav-button-text has-text-black",
                                  },
                                  [_vm._v("Feedback")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("b-dropdown-item", { attrs: { "aria-role": "menuitem" } }, [
                  _c(
                    "div",
                    { staticClass: "menu-button", on: { click: _vm.signOut } },
                    [
                      _c("fa", {
                        style: { color: _vm.menuButtonIconColor },
                        attrs: { icon: "arrow-right-from-bracket", size: "sm" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "nav-button-text has-text-black" },
                        [_vm._v("Sign Out")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      2
    ),
    _vm._v(" "),
    _vm.deviceType === "mobile"
      ? _c(
          "div",
          { staticClass: "burger-container", on: { click: _vm.toggleMenu } },
          [
            _c("fa", {
              style: { color: _vm.profileIconColor },
              attrs: {
                icon: _vm.localIsMenuActive ? "arrow-right" : "bars",
                size: "2xl",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }